




import { Component, mixins } from '@niknevis/vue-modules'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsis.vue'
import AdminDownloadInvoiceButton from '@/modules/invoice/components/admin/AdminDownloadInvoiceButton.vue'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'

@Component({
  components: {
    TesTr
  }
})
export default class AdminInvoiceForModelTableRow extends mixins<TesTableRow>(TesTableRow) {
  private columnComponents = {
    title: {
      component: TextEllipsis,
      handler: value => ({ text: value })
    },
    due_date: {
      component: DateTooltipped,
      handler: value => ({ isoDate: value })
    },
    paid_at: {
      component: DateTooltipped,
      handler: value => ({ isoDate: value })
    },
    download: {
      component: AdminDownloadInvoiceButton,
      handler: (value, row) => ({ invoiceId: row.id })
    }
  }
}
